// ONLY MODIFY THIS FILE BY RUNNING THE FOLLOWING COMMAND:
// php artisan react:enum

export const ConnectAccountStatus = {
  Verified: {
    Name: 'Verified',
    Value: 'verified',
  },
  Restricted: {
    Name: 'Restricted',
    Value: 'restricted',
  },
  PendingVerification: {
    Name: 'Pending Verification',
    Value: 'pending_verification',
  },
  Incomplete: {
    Name: 'Incomplete',
    Value: 'incomplete',
  },
  NotCreated: {
    Name: 'Not Created',
    Value: 'not_created',
  },
} as const

export type ConnectAccountStatusValue =
  (typeof ConnectAccountStatus)[keyof typeof ConnectAccountStatus]['Value']
